import { Routes } from '@angular/router';
import {AppComponent} from "./app.component";
import {TourComponent} from "./tour/tour.component";
import {TourOverviewComponent} from "./tour-overview/tour-overview.component";
import {TourCreatorComponent} from "./tour-creator/tour-creator.component";
import {AuthGuard, hasCustomClaim} from "@angular/fire/auth-guard";

const adminOnly = () => hasCustomClaim('admin');

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/tours',
    pathMatch: 'full'
  },
  {
    path: 'tours',
    component: TourOverviewComponent
  },
  {
    path: 'tours/add',
    component: TourCreatorComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: adminOnly }
  },
  {
    path: 'tours/edit/:id',
    component: TourCreatorComponent,
    canActivate: [AuthGuard],
    data: { authGuardPipe: adminOnly }
  },
  {
    path: 'tours/view/:id',
    component: TourComponent
  },
];
